import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBAEaN3We14L03ANIvtRBbfagsOcIrCjXo",
  authDomain: "peerfectcv.firebaseapp.com",
  projectId: "peerfectcv",
  storageBucket: "peerfectcv.firebasestorage.app",
  messagingSenderId: "819643624275",
  appId: "1:819643624275:web:1466ad70948c52f48a0fa6"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);